var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "team" } },
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: "Team" }], select: true },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "route-page-content breadcrumb-content" },
        [
          _c("UsersMenu", {
            model: {
              value: _vm.selectedTab,
              callback: function ($$v) {
                _vm.selectedTab = $$v
              },
              expression: "selectedTab",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-content-wrapper" },
            [
              _vm.selectedTab === "users" ? _c("Users") : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "roles" ? _c("Roles") : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "departments" ? _c("Subjects") : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "banned-visitors"
                ? _c("BannedVisitors")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }